import { StatsAdapterInterface } from '../../../stats/adapter.interface';
import { StatsContextInterface } from '../../../stats/context.interface';
import { Snowplow2StatsSchemaSerpResultContextInterface } from '../schema/serp-result-context.interface';
import { StatsDataEntityInterface } from '../../../stats/data/entity.interface';
import { Snowplow2StatsAdapterProductType } from './product-type';
import { StatsDataPropertyInterface } from '../../../stats/data/property.interface';

export class Snowplow2StatsAdapterSchemaSerpResultContext implements StatsAdapterInterface {
  /**
   *
   * @param rawData
   * @param context
   */
  constructor(protected rawData: StatsDataEntityInterface, protected context: StatsContextInterface) {}

  /**
   * @inheritDoc
   */
  public getData(): Snowplow2StatsSchemaSerpResultContextInterface {
    if (!this.context.local.pagination) {
      throw new Error('Stats context "pagination" is not set.');
    }

    const schema: Snowplow2StatsSchemaSerpResultContextInterface = {
      schema: 'iglu:ae.propertyfinder/serp_result_context/jsonschema/1-0-2',
      data: {
        current_page_pos: (<StatsDataPropertyInterface>this.rawData).positionPage,
        current_page: this.context.local.pagination.pageCurrent,
        results_pos: (<StatsDataPropertyInterface>this.rawData).position,
        format: 'list',
        product: new Snowplow2StatsAdapterProductType(this.rawData).getData(),
        rsp: (<StatsDataPropertyInterface>this.rawData).rsp,
        rss: (<StatsDataPropertyInterface>this.rawData).rss,
      },
    };

    return schema;
  }
}
